module.exports = new __parcel__URL__("C7O1.bf7cc86a.png").toString();